export default {
  selectSize: 'Bitte wählen Sie die vollständige Spezifikation aus',
  inventory: 'Lagerbestand',
  num: 'Menge',
  nimNumTips: 'Mindestbestellmenge: {num}',
  addCart: 'In den Warenkorb',
  nowBuy: 'Jetzt kaufen',
  remark: 'Nachricht hinterlassen',
  goShop: 'SHOP BETRETEN',
  productTotalPrice: 'Der Gesamtpreis des Produkts',
  productDetail: 'Produktdetails',
  sizeParams: 'Spezifikationsparameter',
  shopNotes: 'Hinweise zum Startseiteen',
  saleService: 'Kundendienst',
  productInfo: 'Produktinformationen',
  buyTips:
    'Bestellungen, die zwischen 09:00 und 18:00 Uhr (Pekinger Zeit) bezahlt werden, werden innerhalb von 6 Stunden bearbeitet (außer Sonntag).',
  buyer: 'Verkäufer',
  selfWarehouse: 'Von Acbuy bestimmtes Lager',
  warehouse: 'Von Acbuy bestimmtes Lager',
  yourAddress: 'Ihre Adresse',
  calcCountryFreight: 'Internationale Versandkosten schätzen',
  holder: {
    remarkHolder:
      'Wenn Sie weitere Wünsche haben, hinterlassen Sie bitte eine Nachricht in den Bemerkungen. Der Agent wird Ihnen bei der Anfrage behilflich sein.',
  },
  supportPayment: 'Verfügbare Zahlungsmethoden',
  disclaimer:
    'Alle Produkte, die für den Startseiteen-Service auf acbuy angezeigt werden, stammen von Drittanbieter-Shopping-Plattformen und werden nicht direkt von acbuy verkauft. Daher übernimmt acbuy keine Haftung und rechtliche Verantwortung für Probleme, die durch Verletzungen von Rechten an geistigem Eigentum und Urheberrechtsverletzungen an Waren entstehen.',
  readAgree: 'Ich habe das Obige gelesen und stimme zu',
  selectAgree: 'Haftungsausschluss nicht akzeptiert',
  copyLink: 'Link kopieren',
  copySuccess: 'Erfolgreich kopiert',
  disclaimer1: 'Haftungsausschluss',
  editPrice: 'Preis bearbeiten',
  editPriceTips:
    'Bitte beachten Sie, dass es ein Problem mit der Gutscheineinlösung gibt. Wir empfehlen dem Nutzer, den Verkaufspreis des Artikels auf den Originalpreis zu ändern.',
  editPriceEnum: {
    0: 'Versandrabatt',
    1: 'Fehler im Webpreis',
    2: 'Mit dem Verkäufer verhandelt',
    3: 'Anderer Grund',
  },
  imgTranslation: 'Bildübersetzung',
  translationTips: 'Klicken Sie auf das Bild, um den Text zu übersetzen',
  originTranslation: 'Original/Übersetzung',
  qcImg: 'Qualitätskontrollfoto',
  deleteShopCollect: 'Möchten Sie die Sammlung dieses Shops wirklich löschen?',
  inTransition: 'In Bearbeitung...',
  originLink: 'Ursprünglicher Link',
  singleProductData: 'Einzelproduktdaten',
  recentlyViewed: 'Zuletzt angesehen',
}
